import "./SuvaiHome.scss"
import Button from "../../components/button/Button"
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { fetchAllRestaurantMenuData, getAllData, getAvailableMenuItems, getAvailableMenus } from "../../../../../../../redux/resturantWidgetSlice";
import MenuItem from "../../components/MenuItem/MenuItem";
import { useHistory } from "react-router"
import ReviewSlider from "../../components/ReviewSlider/ReviewSlider"
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests"
import { sortByOrderAscending } from "../../helper/helper"
const SuvaiHome = () => {
    const company = useSelector((state) => state.companyData.company);
    const { menuData, defualtSelectedLocation, organizationID, } = useSelector((state) => state.resturantData);
    const [data, setData] = useState(null)
    const [itemsData, setItemsData] = useState(data)
    const [isLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [email, setEmail] = useState("")
    const [errors, setErrors] = useState({
        email: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "home")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const fetchMenuData = useCallback(() => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: company?.LocationID,
            OrganizationID: company?.OrganisationID,
            UserID: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? userId : "",
            Type: "MENU"
        }));

    }, [dispatch, defualtSelectedLocation, organizationID]);
    useEffect(() => {
        setIsLoading(true)
        fetchMenuData();

    }, []);
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);

        });
    }, [menuData]);
    useEffect(() => {
        if (data) {
            const menuDataObject = data
            let filteredCategories = getAvailableMenus(
                menuDataObject.data.Menu,
                menuDataObject.data.Categories
            )?.slice(0, 5)
            let filteredItems = getAvailableMenuItems(
                menuDataObject.data.Items,
                filteredCategories
            )
            const updatedData = {
                ...menuDataObject.data,
                Categories: filteredCategories,
                Items: filteredItems
            };
            setCategories(filteredCategories);
            setItemsData(updatedData);
            setIsLoading(false)
        }

    }, [isLoading, data]);
    const getCatgoryItems = (menuEntities) => {
        if (!menuEntities || !Array.isArray(menuEntities) || !itemsData?.Items) return [];
        const menuItemIDs = menuEntities.flatMap(entity => entity.ID);
        const items = itemsData.Items.filter(item => menuItemIDs.includes(item.MenuItemID));

        return items.slice(0, 5) || [];
    }
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;

        const newErrors = {
            email: ""
        };

        const trimmedEmail = email.trim();

        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.companyID || "",
            "Name": "",
            "Email": email,
            "PhoneNo": "",
            "Message": "",
            "Subject": "Dosa N Chutney",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const getImages = (images) => {
        const result = [];
        for (let i = 0; i < images.length; i += 3) {
            result.push(images.slice(i, i + 3));
        }
        return result;
    };
    const getHeroTextontainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-hero-textCont-right-header":
                return <div className="SuvaiHome-hero-textCont-right-header">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-hero-textCont-right-content":
                return <div className="SuvaiHome-hero-textCont-right-content">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-hero-textCont-right-btn":
                return <div className="SuvaiHome-hero-textCont-right-btn">
                    <Button
                        text={component?.Props.btnText}
                        padding={component?.Props?.padding}
                        width={component?.Props.width}
                        type={component?.Props.type}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href !== "") {
                                window.open(component?.Props?.href, '_blank')
                            }
                        }} />
                </div>
            default:
                return <div />
        }

    }
    const getHeroTextontainer = (components) => {
        return (<div className="SuvaiHome-hero-textCont-right">
            {sortByOrderAscending(components).map((component, key) => {
                return getHeroTextontainerComponents(component)
            })}
        </div>)
    }
    const getRightTextContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-hero-textCont-vertical":
                return <div className="SuvaiHome-hero-textCont-vertical">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-hero-textCont-right":
                return getHeroTextontainer(component?.Components)
            default:
                return <div />
        }

    }
    const getRightTextContainer = (components) => {
        return (<div className="SuvaiHome-hero-textCont" >
            {sortByOrderAscending(components).map((component, key) => {
                return getRightTextContainerComponents(component)
            })}
        </div>)
    }
    const getHeroContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-hero-Imagecontainer":
                return <div className="SuvaiHome-hero-imageCont"
                    style={{
                        backgroundImage: `url(${component?.Props?.bgSrc})`
                    }} />
            case "SuvaiHome-hero-TextContainer":
                return getRightTextContainer(component?.Components)
            default:
                return <div />
        }

    }
    const getHeroContainer = (components) => {
        return (<div className="SuvaiHome-hero">
            {sortByOrderAscending(components).map((component, key) => {
                return getHeroContainerComponents(component)
            })}
        </div>)
    }
    const getcomponentOneContainer = (data) => {
        return (<div className="SuvaiHome-componentOne">
            {data?.map((value, key) => {
                return (
                    <div key={key} className="SuvaiHome-componentOne-item"
                        style={{
                            backgroundImage: `linear-gradient(0deg, #090B09 0%, rgba(9, 11, 9, 0) 60%), url(${value?.src})`
                        }} >
                        <div className="SuvaiHome-componentOne-item-header">{value.header}
                        </div>
                        <div className="SuvaiHome-componentOne-item-content">{value.content}
                        </div>
                    </div>
                )
            })}
        </div>)
    }
    const getComponentTwoComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-componentTwo-subheader":
                return <div className="SuvaiHome-componentTwo-subheader">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentTwo-header":
                return <div className="SuvaiHome-componentTwo-header">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentTwo-content":
                return <div className="SuvaiHome-componentTwo-content">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentTwo-line":
                return <div className="SuvaiHome-componentTwo-line" />
            default:
                return <div />
        }

    }
    const getComponentTwoContainer = (components) => {
        return (<div className="SuvaiHome-componentTwo">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponentTwoComponents(component)
            })}
        </div>)
    }
    const getcomponentThreeContainer = (data) => {
        return (<div className="SuvaiHome-componentThree">
            {data?.map((value, key) => {
                return (
                    <div key={key} className="SuvaiHome-componentThree-item"
                        style={{
                            backgroundImage: `linear-gradient(0deg, #090B09 0%, rgba(9, 11, 9, 0) 60%), url(${value?.src})`
                        }} >
                        <div className="SuvaiHome-componentThree-item-content">{value.content}
                        </div>
                        <div className="SuvaiHome-componentThree-item-header">{value.header}
                        </div>

                    </div>
                )
            })}
        </div>)
    }
    const getComponentFourponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-componentFour-header":
                return <div className="SuvaiHome-componentFour-header">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentFour-grid":
                return <div className="SuvaiHome-componentFour-grid">
                    {categories?.map((category) => {
                        return (
                            <MenuItem
                                items={
                                    getCatgoryItems(category.MenuEntities)
                                }
                                headerText={category?.Title?.en}
                            />)
                    })}</div>
            case "SuvaiHome-componentTwo-line":
                return <div className="SuvaiHome-componentFour-line" />
            case "SuvaiHome-componentFour-btn":
                return <div className="SuvaiHome-componentFour-btn">
                    <Button
                        text={component?.Props.btnText}
                        type={component?.Props.type}
                        onClick={() => {
                            history.push(component?.Props?.href)

                        }} />
                </div>
            default:
                return <div />
        }

    }
    const getComponentFourContainer = (components) => {
        return (<div className="SuvaiHome-componentFour">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponentFourponents(component)
            })}
        </div>)
    }
    const getcomponentFiveContainer = (data) => {
        return (<div className="SuvaiHome-componentFive">
            {getImages(data).map((img, key) =>
            (
                <div className={`SuvaiHome-componentFive-left ${key % 2 === 0 ? "" : "reversed"}`} key={key}
                >
                    <img alt="" src={img[0].src} className="SuvaiHome-componentFive-left-img" />
                    <div className="SuvaiHome-componentFive-left-img-list">
                        <img alt="" src={img[1].src} />
                        <img alt="" src={img[2].src} />
                    </div>
                </div >
            )
            )}
        </div>)
    }
    const getcomponentSevenFlexComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-componentSeven-flex-grid2":
                return <div className="SuvaiHome-componentSeven-flex-grid2">
                    {component?.Data?.map((data, key) => {
                        return (
                            <div key={key} className="SuvaiHome-componentSeven-flex-grid2-item"
                                style={{
                                    backgroundImage: `linear-gradient(0deg, #090B09 0%, rgba(9, 11, 9, 0) 60%), url(${data?.src})`
                                }} >
                                <div className="SuvaiHome-componentSeven-flex-grid2-item-content">{data.content}
                                </div>
                                <div className="SuvaiHome-componentSeven-flex-grid2-item-header">{data.header}
                                </div>

                            </div>
                        )
                    })}
                </div>
            case "SuvaiHome-componentSeven-flex-grid":
                return <div className="SuvaiHome-componentSeven-flex-grid">
                    {component?.Data?.map((data, key) => {
                        return (
                            <div key={key} className="SuvaiHome-componentSeven-flex-grid-item"
                                style={{
                                    backgroundImage: `linear-gradient(0deg, #090B09 0%, rgba(9, 11, 9, 0) 60%), url(${data?.src})`
                                }} >
                                <div className="SuvaiHome-componentSeven-flex-grid-item-content">{data.content}
                                </div>
                                <div className="SuvaiHome-componentSeven-flex-grid-item-header">{data.header}
                                </div>

                            </div>
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    const getcomponentSevenFlexContainer = (components) => {
        return (<div className="SuvaiHome-componentSeven-flex">
            {sortByOrderAscending(components).map((component, key) => {
                return getcomponentSevenFlexComponents(component)
            })}

        </div>)
    }
    const getComponentSevenComponents = (component) => {
        switch (component.ID) {
            case "uvaiHome-componentSeven-header":
                return <div className="uvaiHome-componentSeven-header">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentSeven-flex":
                return getcomponentSevenFlexContainer(component?.Components)
            default:
                return <div />
        }

    }
    const getcomponentSevenContainer = (components) => {
        return (<div className="SuvaiHome-componentSeven">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponentSevenComponents(component)
            })}

        </div>)
    }
    const getComponentEightComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-componentEight-inner-header":
                return <div className="SuvaiHome-componentEight-inner-header">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentEight-inner-content":
                return <div className="SuvaiHome-componentEight-inner-content">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentEight-subscribe":
                return <>
                    <div className="SuvaiHome-componentEight-inner-inputCont">
                        <div>
                            <input className={`SuvaiHome-componentEight-inner-inputCont-input ${errors.email !== "" ? "error" : ""}`}
                                placeholder={"Enter your email"}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                    setErrors({
                                        ...errors,
                                        ["email"]: "",
                                    });

                                }}
                                value={email} />
                            {
                                errors.email !== "" && < div className="input-error-text">
                                    {errors.email}
                                </div>
                            }</div>
                        <Button
                            text={component?.Props.btnText}
                            type={component?.Props.type}
                            onClick={handleContact}
                            loading={loading}
                            width={window.screen.width < 900 ? "calc(100vw - 32px)" : ""} />
                    </div>
                    {showSuccess && < div className="succes-alert">
                        Subscription successful! Thank you. </div>}</>
            default:
                return <div />
        }

    }
    const getcomponentEightContainer = (components) => {
        return (<div className="SuvaiHome-componentEight">
            <div className="SuvaiHome-componentEight-inner">
                {sortByOrderAscending(components).map((component, key) => {
                    return getComponentEightComponents(component)
                })}
            </div>

        </div>)
    }
    const getcomponentNineContainer = (data) => {
        return (<div className="SuvaiHome-componentNine-grid">
            {data.map((item, index) => {
                return (
                    <div key={index} className="SuvaiHome-componentNine-grid-item">
                        <img alt="" src={item.src} className="SuvaiHome-componentNine-grid-item-img" />
                        <div className="SuvaiHome-componentNine-grid-item-header">{item.header}</div>
                        <div className="SuvaiHome-componentNine-grid-item-content">{item.content}</div>


                    </div>
                )
            })}
        </div>)
    }
    const getComponentTenTextontainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-componentTen-textContWarpper-textCont-header":
                return <div className="SuvaiHome-componentTen-textContWarpper-textCont-header">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentTen-textContWarpper-textCont-content":
                return <div className="SuvaiHome-componentTen-textContWarpper-textCont-content">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentTen-textContWarpper-textCont-content2":
                return <div className="SuvaiHome-componentTen-textContWarpper-textCont-content2">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentTen-textContWarpper-textCont-btn":
                return <div className="SuvaiHome-componentTen-textContWarpper-textCont-btn">
                    <Button
                        text={component?.Props.btnText}
                        type={component?.Props.type}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href !== "") {
                                window.open(component?.Props?.href, '_blank')
                            }
                        }} />
                </div>
            default:
                return <div />
        }

    }
    const getComponentTenTextontainer = (components) => {
        return (<div className="SuvaiHome-componentTen-textContWarpper-textCont">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponentTenTextontainerComponents(component)
            })}
        </div>)
    }
    const getcomponentTenContainerRightTextContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-componentTen-textContWarpper-vertical":
                return <div className="SuvaiHome-componentTen-textContWarpper-vertical">
                    {component?.Props.text}
                </div>
            case "SuvaiHome-componentTen-textContWarpper-textCont":
                return getComponentTenTextontainer(component?.Components)
            default:
                return <div />
        }

    }
    const getcomponentTenContainerRightTextContainer = (src, components) => {
        return (<div className="SuvaiHome-componentTen-textContWarpper"
            style={{
                backgroundImage:
                    window.screen.width < 900 ? `linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%), url(${src})` : ""
            }}>
            {sortByOrderAscending(components).map((component, key) => {
                return getcomponentTenContainerRightTextContainerComponents(component)
            })}
        </div>)
    }
    const getcomponentTenContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-componentTen-imageCont":
                return <div className="SuvaiHome-componentTen-imageCont"
                    style={{
                        backgroundImage: `linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%), url(${component?.Props?.bgSrc})`
                    }} />
            case "SuvaiHome-componentTen-textContWarpper":
                return getcomponentTenContainerRightTextContainer(component?.Props?.bgSrc, component?.Components)
            default:
                return <div />
        }

    }
    const getcomponentTenContainer = (components) => {
        return (<div className="SuvaiHome-componentTen">
            {sortByOrderAscending(components).map((component, key) => {
                return getcomponentTenContainerComponents(component)
            })}
        </div>)
    }
    const getcomponentFixedContainerComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-MobileFixed-button":
                return <Button
                    text={component?.Props.btnText}
                    padding={component?.Props?.padding}
                    width={component?.Props.width}
                    type={component?.Props.type}
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href !== "") {
                            window.open(component?.Props?.href, '_blank')
                        }
                    }} />
            default:
                return <div />
        }

    }
    const getcomponentFixedContainer = (components) => {
        return (<div className="SuvaiHome-MobileFixed">
            {sortByOrderAscending(components).map((component, key) => {
                return getcomponentFixedContainerComponents(component)
            })}
        </div>)
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "SuvaiHome-hero":
                return getHeroContainer(component?.Components)
            case "SuvaiHome-componentOne":
                return getcomponentOneContainer(component?.Data)
            case "SuvaiHome-componentTwo":
                return getComponentTwoContainer(component?.Components)
            case "SuvaiHome-componentThree":
                return getcomponentThreeContainer(component?.Data)
            case "SuvaiHome-componentFour":
                return getComponentFourContainer(component?.Components)
            case "SuvaiHome-componentFive":
                return getcomponentFiveContainer(component?.Data)
            case "SuvaiHome-componentSix":
                return <div className="SuvaiHome-componentSix">
                    <ReviewSlider
                        reviews={component?.Data} />
                </div>
            case "SuvaiHome-componentSeven":
                return getcomponentSevenContainer(component?.Components)
            case "SuvaiHome-componentEight":
                return getcomponentEightContainer(component?.Components)
            case "SuvaiHome-componentNine":
                return getcomponentNineContainer(component?.Data)
            case "SuvaiHome-componentTen":
                return getcomponentTenContainer(component?.Components)
            case "SuvaiHome-MobileFixed":
                return getcomponentFixedContainer(component?.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="SuvaiHome">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)
            })}
        </div >
    )
}
export default SuvaiHome 